import React from "react";
import StaffSidebar from "./StaffSidebar";
import "./StaffLayout.css";

/**
 * StaffLayout component
 * Provides a consistent layout structure for all staff pages
 * Includes the StaffSidebar and wraps the main content
 */
const StaffLayout = ({ children }) => {
  return (
    <div className="staff-layout">
      <StaffSidebar />
      <main className="staff-layout-content">{children}</main>
    </div>
  );
};

export default StaffLayout;
